import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { Wso2CoreService } from '@services/wso2-core.service';
import moment from 'moment';
import { ToastrService } from 'ngx-toastr';
import { take } from 'rxjs/operators';
import { DadosEmpresaService } from 'src/app/services/dados-empresa.service';
import { cpfValidator } from 'src/app/validators/cpf-validator';
import { DomUtilsService } from '@utils/DomUtilsService';
import { PageLayoutComponent } from '../../components/page-layout/page-layout.component';
import { NgxMaskDirective } from 'ngx-mask';
import { SelectComponent } from '../../components/select/select.component';
import { DateMaskDirective } from '../../directives/date-mask.directive';
import { MatDatepickerInput, MatDatepickerToggle, MatDatepicker } from '@angular/material/datepicker';
import { MatSuffix } from '@angular/material/form-field';
import { NgClass } from '@angular/common';

@Component({
    selector: 'app-adicionar-contato',
    templateUrl: './adicionar-contato.component.html',
    styleUrls: [],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [PageLayoutComponent, FormsModule, ReactiveFormsModule, NgxMaskDirective, SelectComponent, DateMaskDirective, MatDatepickerInput, MatDatepickerToggle, MatSuffix, MatDatepicker, NgClass]
})
export class AdicionarContatoComponent implements OnInit {

  public idEmpresaLogada: string = localStorage.idEmpresaLogada;
  public formulario: UntypedFormGroup;
  public departamentos: any = null;
  public departamentosOptions: any = null;
  public cargos: any = null;
  public cargosOptions: any = null;

  // letIAVEIS DOS ALERTS
  public alertLoading: boolean = false;
  public alertSucesso: boolean = false;
  public alertError: boolean = false;
  public mensagemErro: string = '';
  public dataValidator : boolean = true;

  constructor(
    private readonly formularioBuilder: UntypedFormBuilder,
    private readonly service: DadosEmpresaService,
    public readonly rota: Router,
    private readonly Toastr: ToastrService,
    private readonly wso2CoreService: Wso2CoreService,
    private readonly domUtils: DomUtilsService
  ) { }

  ngOnInit(): void {
    this.consultaDepartamentos();
    this.consultaCargos();
    this.contruirFormulario();
  }

  contruirFormulario() {
    this.formulario = this.formularioBuilder.group({
      'nomeCompleto': ['', Validators.compose([Validators.required])],
      'cpf': ['', Validators.compose([Validators.required, cpfValidator()])],
      'genero': ['M', Validators.compose([Validators.required])],
      'dataNascimento': [''],
      'email': ['', Validators.compose([Validators.required])],
      'telefone': ['', Validators.compose([Validators.required])],
      'ramal': [''],
      'departamento': ['', Validators.compose([Validators.required])],
      'cargo': ['', Validators.compose([Validators.required])]
    });
  }

  consultaDepartamentos() {
    this.service.consultaDepartamentos()
    .pipe(take(1))
    .subscribe({
      next: (response: any) => {
        if (response.status === 'OK') {
          this.departamentos = response.response;
          this.departamentosOptions = this.departamentos.map(departamento => {
            return {
              value: `${departamento.idDeptoWeb}-${departamento.descDeptoWeb}`,
              description: departamento.descDeptoWeb
            }
          })
        } else { this.departamentos = false; }
      },
      error: (erro: any) => {
        console.error(erro);
        this.departamentos = false;
      }
    })
  }

  consultaCargos() {
    this.service.consultaCargos()
    .pipe(take(1))
    .subscribe({
      next: (response: any) => {
        if (response.status === 'OK') {
          this.cargos = response.response;
          this.cargosOptions = this.cargos.map((cargo) => {
            return {
              value: `${cargo.idCargosWeb}-${cargo.descCargosWeb}`,
              description: cargo.descCargosWeb,
            }
          })
        } else { this.cargos = false; }
      },
      error: (error: any) => {
        console.error(error);
        this.cargos = false;
      }
    });
  }

  adicionarContato() {
    this.alertLoading = true;

    let objContato = {
      name: this.formulario.value.nomeCompleto,
      ddd: this.formulario.value.telefone.slice(0, 2),
      phoneNumber: this.formulario.value.telefone.slice(2),
      email: this.formulario.value.email,
      companyPositionId: Number.parseInt(this.formulario.value.cargo.split('-')[0]),
      cpf: this.formulario.value.cpf,
      departmentId: Number.parseInt(this.formulario.value.departamento.split('-')[0]),
      gender: this.formulario.value.genero,
      birthDate: moment(this.formulario.value.dataNascimento).format('DD/MM/yyyy'),
      extensionLine: this.formulario.value.ramal,
      portalAccess: 'S'
    }

    this.wso2CoreService.saveContact(objContato)
    .pipe(take(1))
    .subscribe({
      next: (response: any) => {
        this.alertLoading = false;
        if (response.status === 'OK') {
          this.alertSucesso = true;
        } else {
          this.alertError = true;
          this.mensagemErro = response.mensagem;
        }
      },
      error: (error: any) => {
        console.error(error);
        this.alertLoading = false;
        this.alertError = true;
        this.mensagemErro = error.error.mensagem;
      }
    });
  }

  voltarAbaContatos() {
    this.rota.navigate(['dados-empresa']);
    this.domUtils.aguardarElementoClique('contatosTab', 1500, 3);
  }

  // Fechar o alerta de sucesso, clicando no botão OK
  fecharAlertSucesso(evento: string) {
    this.alertSucesso = false;
    this.rota.navigate(['dados-empresa']);
    this.domUtils.aguardarElementoClique('contatosTab', 1200, 4);
  }

  // Fechar o alerta de erro, clicando no botão OK
  fecharAlertError(evento: string) { this.alertError = false; }

  somenteNumeros(e: any) {
    let charCode = e.charCode ?? e.keyCode;

    if (charCode != 8 && charCode != 9) {
      const max = 10;
      if ((charCode < 48 || charCode > 57) || (e.target.value.length >= max)) return false;
    }
  }

  validadata() {
  this.dataValidator = true;

  if (!this.formulario.value.dataNascimento) return;

  const idade = this.calcularIdade(this.formulario.value.dataNascimento);
  this.validarIdade(idade);
  }

  private calcularIdade(dataNascimento: any): number {
    let data = dataNascimento.toISOString();
    data = data.replace(/\//g, '-');
    const dataArray = data.split('-');

    if (dataArray[0].length !== 4) {
      data = `${dataArray[2]}-${dataArray[1]}-${dataArray[0]}`;
    }

    const hoje = new Date();
    const nasc = new Date(data);
    let idade = hoje.getFullYear() - nasc.getFullYear();
    const m = hoje.getMonth() - nasc.getMonth();

    if (m < 0 || (m === 0 && hoje.getDate() < nasc.getDate())) idade--;

    return idade;
  }

  private validarIdade(idade: number): void {
    if (idade < 0) {
      this.Toastr.error('Data de Nascimento Inválida !', '', { timeOut: 2000 });
      this.dataValidator = false;
    } else if (idade < 14) {
      this.Toastr.error('Idade mínima deve ser 14 anos', '', { timeOut: 2000 });
      this.dataValidator = false;
    } else if (idade > 80) {
      this.Toastr.error('Idade máxima deve ser 80 anos', '', { timeOut: 2000 });
      this.dataValidator = false;
    } else {
      this.dataValidator = true;
    }
  }

  get formControl() {
    return this.formulario.controls;
  }
}
